import {
  faDashboard,
  faTools,
  faClipboardList,
  faShieldAlt, // 🆕 Ícone para garantias
} from '@fortawesome/free-solid-svg-icons'

export const sectionsManutenção = [
  {
    title: 'Dashboard',
    icon: faDashboard,
    to: '/dashboard',
    requiredPermission: 'Listar dashboard de manutenção',
  },
  {
    title: 'Manutenção',
    icon: faTools,
    requiredPermission: 'Listar manutenções',
    items: [
      // 🆕 Transformado em seção com sub-itens
      {
        name: 'Lista',
        icon: faTools,
        to: '/manutencao',
        requiredPermission: 'Listar manutenções',
      },
      {
        name: 'Garantias', // 🆕
        icon: faShieldAlt,
        to: '/manutencao/garantias',
        requiredPermission: 'Listar manutenções',
      },
    ],
  },
  {
    title: 'Relatórios',
    icon: faClipboardList,
    requiredPermission: 'Listar relatórios',
    items: [
      {
        name: 'Manutenções',
        icon: faTools,
        to: '/manutencao/relatorios/manutencoes',
        requiredPermission: 'Listar manutenções',
      },
    ],
  },
]
